export const STAT_GRID_PAGING = "STAT_GRID_PAGING";
export const STAT_GRID_SORTING = "STAT_GRID_SORTING";
export const STAT_GRID_FILTERING = "STAT_GRID_FILTERING";
export const STAT_GRID_LOADING = "STAT_GRID_LOADING";
export const TOGGLE_HIDE_FILTER = "TOGGLE_HIDE_FILTER";
export const STAT_CLEAR_DATA = "STAT_CLEAR_DATA";

export const ROUTINE_GRID_PAGING = "ROUTINE_GRID_PAGING";
export const ROUTINE_GRID_SORTING = "ROUTINE_GRID_SORTING";
export const ROUTINE_GRID_FILTERING = "ROUTINE_GRID_FILTERING";
export const ROUTINE_GRID_LOADING = "ROUTINE_GRID_LOADING";
export const ROUTINE_CLEAR_DATA = "ROUTINE_CLEAR_DATA";

export const TIMEDDRAW_GRID_PAGING = "TIMEDDRAW_GRID_PAGING";
export const TIMEDDRAW_GRID_SORTING = "TIMEDDRAW_GRID_SORTING";
export const TIMEDDRAW_GRID_FILTERING = "TIMEDDRAW_GRID_FILTERING";
export const TIMEDDRAW_GRID_LOADING = "TIMEDDRAW_GRID_LOADING";
export const TIMEDDRAW_CLEAR_DATA = "TIMEDDRAW_CLEAR_DATA";

export const HOMEHEALTH_GRID_PAGING = "HOMEHEALTH_GRID_PAGING";
export const HOMEHEALTH_GRID_SORTING = "HOMEHEALTH_GRID_SORTING";
export const HOMEHEALTH_GRID_FILTERING = "HOMEHEALTH_GRID_FILTERING";
export const HOMEHEALTH_GRID_LOADING = "HOMEHEALTH_GRID_LOADING";
export const HOMEHEALTH_CLEAR_DATA = "HOMEHEALTH_CLEAR_DATA";